"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.footerSignature = void 0;
const footerSignature = () => {
    return `© ${new Date().getFullYear()} ProHabits, Inc.`;
};
exports.footerSignature = footerSignature;
//# sourceMappingURL=time.js.map